import { QueryOptions } from "../common/lib/fetch/useQuery";
import useUserQuery from "../common/lib/fetch/useUserQuery";
import { useUser } from "../userAccess/useUser";

export type PastOrder = {
  id: string;
  transactionNumbers: string | null;
  orderId: string | null;
  orderNumber: string | null;
  loadoutGroupName: string | null;
  orderNumbers: string[] | null;
  orderIds: string[] | null;
  stagedOrderId: string;
  customerNames: string[] | null;
  driverEmail: string | null;
  loaderEmail: string | null;
  products: string[] | null;
  quantity: string | null;
  tareWeight: string | null;
  grossWeight: string | null;
  stagedAt: string | null;
  completedAt: string | null;
  checkedInAt: string | null;
  tareAt: string | null;
  arrivedAtBayAt: string | null;
  dispensingCompletedAt: string | null;
  manuallyLoadedAt: string | null;
  outboundArrivedAt: string | null;
  grossAt: string | null;
  signedAt: string | null;
  bayName: string | null;
  tareScaleName: string | null;
  grossScaleName: string | null;
}

export type PastOrdersResponse = {
  items: PastOrder[];
  totalCount: number;
  totalPages: number;
  page: number;
  pageSize: number;
}

export type DateRange = 'Days30' | 'Days90' | 'Days365';
export type FilterField = 'OrderNumber' | 'LoadoutGroup' | 'TransactionNumber' | 'Product';

const useGetPastOrders = (
  page: number = 0,
  dateRange: DateRange = 'Days30',
  filterField?: FilterField,
  filterValue?: string,
  options?: QueryOptions<PastOrdersResponse>
) => {
  const user = useUser();
  const baseUrl = `/api/sites/${user.selectedSite!.id}/pastOrders`;
  const urlParams = new URLSearchParams();

  urlParams.append("page", page.toString());
  urlParams.append("dateRange", dateRange);
  if (filterField) urlParams.append("filterField", filterField);
  if (filterValue) urlParams.append("filterValue", filterValue);

  return useUserQuery<PastOrdersResponse>({
    path: `${baseUrl}?${urlParams.toString()}`
  }, options);
}

export default useGetPastOrders;
